<div class="relative inline-block text-left dropdown-container">
  <div (click)="toggleDropdown()">
    <ng-content></ng-content>
  </div>
  @if (isDropdownOpen){
  <div
    class="mt-2 w-48 rounded-xl shadow-dropdown bg-white border border-stone-200/90 z-[999] overflow-hidden animate-fade-in absolute"
    [ngClass]="align === 'left' ? 'left-0 origin-top-left' : 'right-0 origin-top-right'">
    <div class="py-1" role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
      @for(item of optionItems(); track item.label) {
      <a class="flex flex-row items-center px-4 py-2 text-sm text-stone-700 hover:text-secondary hover:bg-surface-muted transition-colors"
        [ngClass]="item.loading || isItemDisabled(item) ? 'cursor-not-allowed opacity-50': 'cursor-pointer'" role="menuitem"
        (click)="!item.loading && !isItemDisabled(item) && getDataSelected(item.callback)">
        @if (item.loading) {
        <app-loading-spinner></app-loading-spinner>
        } @else {
        @if (item.src) {
        <img [src]="item.src" alt="Icon" class="w-4 h-4 mr-2" />
        }
        @if (item.icon === 'square-pen') {
        <app-icon-square-pen class="mr-2"></app-icon-square-pen>
        }
        }
        {{item.label}}
      </a>
      }
    </div>
  </div>
  }

</div>